import { render, staticRenderFns } from "./userRedList.vue?vue&type=template&id=14431574&scoped=true&"
import script from "./userRedList.vue?vue&type=script&lang=js&"
export * from "./userRedList.vue?vue&type=script&lang=js&"
import style0 from "./userRedList.vue?vue&type=style&index=0&id=14431574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14431574",
  null
  
)

export default component.exports